import React from 'react'
import { Box, Typography, Button, Divider, IconButton } from '@mui/material'
import FileUploadArea from './FileUploadArea.jsx'
import { formatDate } from '../utils/documentUtils.js'
import { getFileIcon } from '../utils/fileIconUtils.jsx'
import fileUtils from '../../../global/utils/fileUtils.js'
import DeleteIcon from '@mui/icons-material/Delete'
import DocumentsHeader from './DocumentsHeader.jsx'

const NoDocumentsTask = ({
  selectedFirm,
  requestTask,
  unmatchedFiles = [],
  files,
  dragOver,
  setDragOver,
  onFileUpload,
  onDrop,
  onRemoveFile,
  submitting,
  onSubmitFiles,
  onFinishTask,
  onDeleteFile,
  isMatchingFiles,
  uploadItems,
  isSaving,
}) => {
  const hasUnmatched = unmatchedFiles && unmatchedFiles.length > 0
  return (
    <Box
      p={4}
      maxWidth="900px"
      mx="auto"
    >
      <DocumentsHeader
        selectedFirm={selectedFirm}
        requestTask={requestTask}
        documents={[]}
        unmatchedFiles={unmatchedFiles}
        onFinishTask={onFinishTask}
        isSaving={isSaving}
      />

      <Box
        sx={{
          mt: 4,
          mb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h3">Requested Documents</Typography>
        {requestTask.documents_range_to_date && (
          <Typography variant="body2">
            <strong>From:</strong>{' '}
            {formatDate(requestTask.documents_range_from_date)} |{' '}
            <strong>To:</strong>{' '}
            {formatDate(requestTask.documents_range_to_date)}
          </Typography>
        )}
      </Box>

      {hasUnmatched &&
        unmatchedFiles.map(file => (
          <Box
            key={file._id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
            padding={1}
            sx={{
              border: '1px solid',
              borderColor: 'grey.300',
              borderRadius: 1,
              bgcolor: 'background.paper',
              '&:hover': {
                bgcolor: 'action.hover',
                borderColor: 'primary.main',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              flexGrow={1}
              overflow="hidden"
              mr={1}
            >
              {getFileIcon(file.fileExtension)}
              <Typography
                variant="body2"
                ml={1}
                noWrap
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {file.filename}
              </Typography>
              <Typography
                variant="body2"
                ml={1}
                sx={{ flexShrink: 0, color: 'text.secondary' }}
              >
                ({fileUtils.formatFileSize(file.fileSize)})
              </Typography>
            </Box>

            <IconButton
              size="small"
              color="error"
              onClick={() => onDeleteFile(file._id, 'unmatched')}
              sx={{ ml: 1 }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}

      {/* File upload area */}
      <FileUploadArea
        files={files}
        dragOver={dragOver}
        setDragOver={setDragOver}
        onFileUpload={onFileUpload}
        onDrop={onDrop}
        onRemoveFile={onRemoveFile}
        submitting={submitting}
        onSubmitFiles={onSubmitFiles}
        hasDocuments={false}
        isMatchingFiles={isMatchingFiles}
        uploadItems={uploadItems}
      />
    </Box>
  )
}

export default NoDocumentsTask
